import { useNavigate } from 'react-router';
import { shouldNavigateToUploadKyc } from '@/pages/UploadKYC/useUploadKYC';
import * as R from '@/Router/routes';
import { Application } from '@/api/getClientApplication';

function useNavigateWithAdditionalAmountBudgetResolution() {
  const navigate = useNavigate();
  const navigateWithAdditionalAmountBudgetResolution = (
    application: Application,
  ): void => {
    if (application?.resolutionDetail === 'UPSALE_OFFER') {
      navigate(R.ADDITIONAL_AMOUNT_NEW_OFFER_INCREASE);
      return;
    }

    if (application?.resolution === 'REJECTED') {
      navigate(R.ADDITIONAL_AMOUNT_REJECT);
      return;
    }

    if (
      application?.resolution === 'MANUAL' &&
      application?.resolutionMessage === 'ASK_FOR_DOCUMENTS'
    ) {
      navigate(R.EXPIRED_INCOME);
      return;
    }

    if (
      application?.resolution === 'MANUAL' &&
      application?.resolutionDetail === 'INSUFFICIENT_PSD2_INCOME'
    ) {
      navigate(R.ADJUST_INCOME);
      return;
    }

    // NOTE: Check if client is required to upload ID Documents
    if (shouldNavigateToUploadKyc(application)) {
      navigate(R.KYC_ADDITIONAL_UPLOAD);
      return;
    }

    // default redirect
    navigate(R.ADDITIONAL_AMOUNT_CONFIRM);
  };

  return { navigateWithAdditionalAmountBudgetResolution };
}

export default useNavigateWithAdditionalAmountBudgetResolution;
